import { render, staticRenderFns } from "./FrequenceDaysCustomisation.vue?vue&type=template&id=731a10ca"
import script from "./FrequenceDaysCustomisation.vue?vue&type=script&lang=ts"
export * from "./FrequenceDaysCustomisation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports